import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/CommunityHero';
import AgencyHistory from './components/AgencyHistory';
import OurProcess from './components/OurProcess';
import InsuranceCarriers from './components/InsuranceCarriers';
import TeamValues from './components/TeamValues';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <AgencyHistory />
      <OurProcess />
      <InsuranceCarriers />
      <TeamValues />
      <Footer />
    </div>
  );
}
